import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

/**
 * Fetches white-label branding (name, logos, colours).
 *
 * <p>Uses a bare axios call rather than the shared interceptor on purpose: this runs on the login
 * page before any token exists, and the shared interceptor redirects to /login on 401/403 — which
 * would loop. The endpoint is public.
 */
export const fetchBranding = async () => {
    const res = await axios.get(`${BASE_URL}/api/public/branding`);
    return res.data;
};
